import React, { useEffect } from "react";
import CombinedLayout from "./Layout/CombinedLayout";
import { Route, Switch, Redirect, HashRouter } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RoutesAfterLogin, RoutesBeforeLogin } from "../Routes/UrlRoutes.js";
import { Get } from "../Api/ApiMethods.js";
import { getUserDetailsUrl } from "../Routes/ApiRoutes";
import { toast } from "react-toastify";

export default function Main() {
  const token = useSelector((state) => state.auth.isSignedIn);
  const dispatch = useDispatch();

  useEffect(() => {
    if (token) {
      Get(getUserDetailsUrl, token)
        .then((res) => {
          if (res.status === 200) {
            if (res.data.user.status === 0) {
              toast.error(
                "You have been disabled by admin. Please ask them to autherize you to login."
              );
              setTimeout(() => {
                dispatch({
                  type: "SIGN_OUT",
                });
                <Redirect to="/login" />;
              }, 2100);
            } else {
              dispatch({
                type: "ADMIN_DATA",
                payload: res.data.user,
              });
            }
          }
        })
        .catch((error) => {
          dispatch({
            type: "SIGN_OUT",
          });
          <Redirect to="/login" />;
        });
    } else {
      dispatch({
        type: "SIGN_OUT",
      });
      <Redirect to="/login" />;
    }
  }, []);

  return (
    <>
      <HashRouter>
        <Switch>
          <Route exact path="/">
            <Redirect to="/home" />
          </Route>
          {RoutesBeforeLogin &&
            RoutesBeforeLogin.map((item, index) => (
              <Route
                key={index}
                exact
                path={item.path}
                component={item.component}
              />
            ))}
          {RoutesAfterLogin &&
            RoutesAfterLogin.map((item, index) => (
              <CombinedLayout
                key={index}
                exact
                path={item.path}
                component={item.component}
              />
            ))}
        </Switch>
      </HashRouter>
    </>
  );
}
